import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { EfaactDataService } from '../efaact.data-service';
import { CompanyCalendar } from './company-calendar.model';

export const entityName = 'CompanyDate';

@Injectable()
export class CompanyCalendarDataService extends EfaactDataService<CompanyCalendar> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    mapItems(item: CompanyCalendar): CompanyCalendar {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.ScheduledDateID,
            ScheduledStartDate: moment(item.ScheduledStartDate).toDate(),
            ScheduledEndDate: moment(item.ScheduledEndDate).toDate()
        };
    }
}
